import { InjectionToken } from '@angular/core';

export interface ApiData {
  apiID: string;
  apiURL: string;
  assetURL: string;
}

export const API_DATA = new InjectionToken<ApiData>('API_DATA_TOKEN');
